module.exports = __webpack_public_path__ + "front/img/register-login-bg.3dad9178.png";